import React from 'react';
import { Box, Skeleton } from '@mui/material';

function UserSkelton() {
  return (
    <Box display="flex" alignItems="center">
      <Skeleton variant="circular" width={36} height={36} />
      <Box width={16} />
      <Skeleton variant="text" width="100px" height={24} />
    </Box>
  );
}

export default UserSkelton;
